<template>
  <div>
    <div class="gray-bg">
      <main-header/>
    </div>
    <div v-if="isLoaded">
      <div v-if="moreProducts.length === 0">
        <v-alert
            text
            type="error"
        >
          محصولی یافت نشد
        </v-alert>
      </div>
      <more-products v-else :productsArray="moreProducts"/>
    </div>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MainHeader from "./mainHeader";
import MoreProducts from "./moreProducts";

let _this = null;

export default {
  name: "vipMoreProducts",
  components: {MainHeader, MoreProducts},
  data: () => ({
    moreProducts: [],
    isLoaded: false,
    showLoaderDialog: false,
  }),
  mounted() {
    _this = this;
    this.getData();
    console.log("Mounted");
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let urlencoded = new URLSearchParams();

      let requestOptions = {
        method: 'POST',
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "/SearchEngine/ShowAllVipProduct", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.showLoaderDialog = false
            _this.moreProducts = JSON.parse(result)
            _this.isLoaded = true
          })
          .catch(error => console.log('error', error));

    }
  }
}
</script>

<style scoped>

</style>
